import { isElementInViewport } from './viewport.js';
const FOCUSABLE_SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
const KEYBOARD_FOCUSABLE_SELECTORS = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]:not([tabindex="-1"])';
const MENUITEM_FOCUSABLE_SELECTORS = 'a[role="menuitem"],frame[role="menuitem"],iframe[role="menuitem"],input[role="menuitem"]:not([type=hidden]):not(:disabled),select[role="menuitem"]:not(:disabled),textarea[role="menuitem"]:not(:disabled),button[role="menuitem"]:not(:disabled),*[tabindex]:not([tabindex="-1"])';
export const handleMouseUpByBlurring = ({ currentTarget, }) => currentTarget.blur();
export function nextFocusableNode(node, filter) {
    const allFocusableElements = [
        ...document.querySelectorAll(FOCUSABLE_SELECTOR),
    ];
    const sliceLocation = allFocusableElements.indexOf(node) + 1;
    const focusableElementsAfterNode = allFocusableElements.slice(sliceLocation);
    for (const focusableElement of focusableElementsAfterNode) {
        if (isElementInViewport(focusableElement) &&
            (!filter || (filter && filter(focusableElement)))) {
            return focusableElement;
        }
    }
    return null;
}
export function findFirstFocusableNode(document, element, onlyDescendants = true) {
    if (!onlyDescendants && matches(document, element, FOCUSABLE_SELECTOR)) {
        return element;
    }
    return element.querySelector(FOCUSABLE_SELECTOR);
}
export function findFirstFocusableNodeIncludingDisabled(document, element) {
    const focusableSelector = `a,button,frame,iframe,input:not([type=hidden]),select,textarea,*[tabindex]`;
    if (matches(document, element, focusableSelector)) {
        return element;
    }
    return element.querySelector(focusableSelector);
}
export function focusFirstFocusableNode(document, element, onlyDescendants = true) {
    var _a;
    (_a = findFirstFocusableNode(document, element, onlyDescendants)) === null || _a === void 0 ? void 0 : _a.focus();
}
export function focusNextFocusableNode(node, filter) {
    const nextFocusable = nextFocusableNode(node, filter);
    if (nextFocusable && nextFocusable instanceof HTMLElement) {
        nextFocusable.focus();
        return true;
    }
    return false;
}
export function findFirstKeyboardFocusableNode(document, element, onlyDescendants = true) {
    if (!onlyDescendants &&
        matches(document, element, KEYBOARD_FOCUSABLE_SELECTORS)) {
        return element;
    }
    return element.querySelector(KEYBOARD_FOCUSABLE_SELECTORS);
}
export function focusFirstKeyboardFocusableNode(document, element, onlyDescendants = true) {
    const firstFocusable = findFirstKeyboardFocusableNode(document, element, onlyDescendants);
    if (firstFocusable) {
        firstFocusable.focus();
        return true;
    }
    return false;
}
export function findLastKeyboardFocusableNode(document, element, onlyDescendants = true) {
    if (!onlyDescendants &&
        matches(document, element, KEYBOARD_FOCUSABLE_SELECTORS)) {
        return element;
    }
    const allFocusable = element.querySelectorAll(KEYBOARD_FOCUSABLE_SELECTORS);
    return allFocusable[allFocusable.length - 1];
}
export function focusLastKeyboardFocusableNode(document, element, onlyDescendants = true) {
    const lastFocusable = findLastKeyboardFocusableNode(document, element, onlyDescendants);
    if (lastFocusable) {
        lastFocusable.focus();
        return true;
    }
    return false;
}
export function wrapFocusPreviousFocusableMenuItem(parentElement, currentFocusedElement) {
    const allFocusableChildren = getMenuFocusableDescendants(parentElement);
    const currentItemIdx = getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement);
    if (currentItemIdx === -1) {
        allFocusableChildren[0].focus();
    }
    else {
        allFocusableChildren[(currentItemIdx - 1 + allFocusableChildren.length) %
            allFocusableChildren.length].focus();
    }
}
export function wrapFocusNextFocusableMenuItem(parentElement, currentFocusedElement) {
    const allFocusableChildren = getMenuFocusableDescendants(parentElement);
    const currentItemIdx = getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement);
    if (currentItemIdx === -1) {
        allFocusableChildren[0].focus();
    }
    else {
        allFocusableChildren[(currentItemIdx + 1) % allFocusableChildren.length].focus();
    }
}
function getMenuFocusableDescendants(element) {
    return element.querySelectorAll(MENUITEM_FOCUSABLE_SELECTORS);
}
function getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement) {
    let currentItemIdx = 0;
    for (const focusableChild of allFocusableChildren) {
        if (focusableChild === currentFocusedElement) {
            break;
        }
        currentItemIdx++;
    }
    return currentItemIdx === allFocusableChildren.length ? -1 : currentItemIdx;
}
function matches(document, node, selector) {
    if (node.matches) {
        return node.matches(selector);
    }
    const matches = (node.ownerDocument || document).querySelectorAll(selector);
    let i = matches.length;
    while (--i >= 0 && matches.item(i) !== node)
        return i > -1;
}
//# sourceMappingURL=focus.js.map